import styles from "./graphwidgets.module.css";
import DashboardPieChart from "./DashboardPieChart";
import { D2C_SERVICES, GraphLabel, HEADER, MY_TICKETS, TAB, WIDGET_NAME } from "../../../../utils/constants/homeConstants";
import SecondaryTooltip from "../../../../components/secondaryToolTip/secondaryToolTip";
import IMAGES from "../../../../assets/images/images";
import CustomDropdownMenu from "../../../../components/customDropdown/CustomDropdown";
import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { MY_INCIDENT_TABS } from "../../../../utils/constants/incidentConstants";
import { MY_SERVICE_TABS } from "../../../../utils/constants/serviceConstants";
import { connect } from "react-redux";
import { setIncidentActiveTab } from "../../../../redux/actions/incidentManagement/incidentTab.action";
import { setServiceActiveTab } from "../../../../redux/actions/newService/service.actions";
import { getCustomerUserCount, getDemandGraph, getIncidentGraph, getOnboardingData } from "../../../../redux/actions/home/home.action";
import { dashboardTime, determineSelectionType, extractYearFromValue, getLastThreeMonths, isWidgetPresent } from "../../../../utils/arrayUtils";
import Shimmer from "../../../../components/shimmer/Shimmer";
import EmptyDataView from "../../../../components/emptydataview/EmptyDataView";
import { redirectDemandFilter } from "../../../../redux/actions/userManagement/redirectDemandFilter.action";
import { setActivePrimaryTab } from "../../../../redux/actions/userManagement/userManagementTab.action";
import { UserManagementTab } from "../../../../utils/constants/userManagementConstant";
import { USER_TYPE } from "../../../../utils/constants/userConstants";
import Calendar from "../../../../components/calendar/Calendar";
import { getUTCTimestamp } from "../../../../utils/dateTime";

const GraphWidget = ({action,selectedCustomerId,...props}) => {
    const chartRef = useRef();
    const isInternalLogin = props?.myRights?.userType === USER_TYPE.INTERNAL;
    const headers = isInternalLogin ? HEADER.INTERNAL : HEADER.CUSTOMER;
    const [hiddenItems, setHiddenItems] = useState([]);
    // const demandOptions = Array.isArray(props.services) ? props.services : [];
    const dropdownOptions = action === WIDGET_NAME.INCIDENT_MANAGEMENT_STATUS_COUNT_WIDGET?MY_TICKETS:action === WIDGET_NAME?.DEMANDS_STATUS_COUNT_WIDGET?D2C_SERVICES:""
    const dropdownHeader = action === WIDGET_NAME.INCIDENT_MANAGEMENT_STATUS_COUNT_WIDGET ? headers.TICKETS :action === WIDGET_NAME.DEMANDS_STATUS_COUNT_WIDGET? headers.DEMANDS:"";
    const [selectedOption, setSelectedOption] = useState(dropdownOptions[0]);
    const [isCustom, setIsCustom] = useState(false)
    const [selectValue, setSelectValue] = useState(getLastThreeMonths()||{ label: "", value: "" });
    const navigate = useNavigate()

    const gotoDetail = () => {
        switch (action) {
            case WIDGET_NAME.INCIDENT_MANAGEMENT_STATUS_COUNT_WIDGET:
                return `/incident-management${selectedOption?.value === TAB.SERVICE_REQUEST? "/serviceRequests" : "/incidents"}`;
            case WIDGET_NAME.DEMANDS_STATUS_COUNT_WIDGET:
                return "/connectivity/demands";
            case WIDGET_NAME.CUSTOMER_ONBOARDING_REQUESTS_WIDGET:
                return "/user-management/onboardingApprovals";
            case WIDGET_NAME.STATUS_WISE_CUSTOMER_USERS_COUNT_WIDGET:
                return `/user-management/customerdetail/${selectedCustomerId}`;
            default:
                return "#";
            }
      }
      const getDetailPayload = (action) => {
        switch (action) {
        //   case WIDGET_NAME.INCIDENT_MANAGEMENT_STATUS_COUNT_WIDGET:
        //     return {
        //       tab: selectedOption?.value === TAB.SERVICE_REQUEST
        //         ? "serviceRequest"
        //         : "incidents",
        //     };
          case WIDGET_NAME.DEMANDS_STATUS_COUNT_WIDGET:
            return {
              tab: TAB.DEMANDS,
            //   filter: selectedOption,
            };
        //   case WIDGET_NAME.CUSTOMER_ONBOARDING_REQUESTS_WIDGET:
        //     return {
        //       tab: UserManagementTab.ON_BOARDING_APPROVALS,
        //     };
          default:
            return {};
        }
      };
    useEffect(()=>{
        const startDate = selectValue.value[0]
        const endDate = selectValue?.value[selectValue?.value?.length-1]
        if(isInternalLogin && selectedCustomerId){
            if(action===WIDGET_NAME.INCIDENT_MANAGEMENT_STATUS_COUNT_WIDGET){
                props?.getIncidentGraph(WIDGET_NAME.INCIDENT_MANAGEMENT_STATUS_COUNT_WIDGET,selectedOption?.value,selectedCustomerId,startDate,endDate)
            }
            if(action===WIDGET_NAME.DEMANDS_STATUS_COUNT_WIDGET){
                props?.getDemandGraph(WIDGET_NAME.DEMANDS_STATUS_COUNT_WIDGET,selectedOption?.value,selectedCustomerId,startDate,endDate)
            }
            if(action===WIDGET_NAME.CUSTOMER_ONBOARDING_REQUESTS_WIDGET){
                props?.getOnboardingData(WIDGET_NAME.CUSTOMER_ONBOARDING_REQUESTS_WIDGET,"","",startDate,endDate)
            }
            if(action===WIDGET_NAME.STATUS_WISE_CUSTOMER_USERS_COUNT_WIDGET){
                props?.getCustomerUserCount(action,"",selectedCustomerId)
            }
        }else if(isInternalLogin){
            if(action===WIDGET_NAME.CUSTOMER_ONBOARDING_REQUESTS_WIDGET){
                props?.getOnboardingData(WIDGET_NAME.CUSTOMER_ONBOARDING_REQUESTS_WIDGET,"","",startDate,endDate)
            }
        }else if(!isInternalLogin){
            if(action===WIDGET_NAME.INCIDENT_MANAGEMENT_STATUS_COUNT_WIDGET){
                props?.getIncidentGraph(WIDGET_NAME.INCIDENT_MANAGEMENT_STATUS_COUNT_WIDGET,selectedOption?.value,"",startDate,endDate)
            }
            if(action===WIDGET_NAME.DEMANDS_STATUS_COUNT_WIDGET){
                props?.getDemandGraph(WIDGET_NAME.DEMANDS_STATUS_COUNT_WIDGET,selectedOption?.value,"",startDate,endDate)
            }
        }
    },[selectedOption,action,selectedCustomerId])
    
    useEffect(() => {
    if (action === WIDGET_NAME.DEMANDS_STATUS_COUNT_WIDGET &&props?.services?.length > 0 &&!selectedOption) {
        setSelectedOption(props.services[0]);}
    }, [props.services]);
    const data = action===WIDGET_NAME.INCIDENT_MANAGEMENT_STATUS_COUNT_WIDGET ? props?.incidentGraphData.statusCount:
    action===WIDGET_NAME.DEMANDS_STATUS_COUNT_WIDGET?props?.demandGraphData.statusCount:
    action===WIDGET_NAME.STATUS_WISE_CUSTOMER_USERS_COUNT_WIDGET? props?.statusWiseCustomerUserCount?.customerUsersStatus:
    action===WIDGET_NAME.CUSTOMER_ONBOARDING_REQUESTS_WIDGET?props?.onBoardingRequestData?.onboardingStats:[]

    const timePeriod = action===WIDGET_NAME.INCIDENT_MANAGEMENT_STATUS_COUNT_WIDGET ? props?.incidentGraphData.timePeriod:
    action===WIDGET_NAME.DEMANDS_STATUS_COUNT_WIDGET?props?.demandGraphData.timePeriod:
    action===WIDGET_NAME.STATUS_WISE_CUSTOMER_USERS_COUNT_WIDGET? props?.statusWiseCustomerUserCount?.timePeriod:
    action===WIDGET_NAME.CUSTOMER_ONBOARDING_REQUESTS_WIDGET?props?.onBoardingRequestData?.timePeriod:[]

    const statusData = data?.filter((item)=>item?.value!==0);
    const total = statusData?.reduce((sum, item) => sum + item.value, 0)
    
    const colorMap = {
        "New Demand":"#FFE168",
        "Quotation":"#89DBE9",
        "Order Form":"#C3BDFE",
        "Service Building":"#C3BDFE",
        "Billing Onboarding":"#CDCDCD",
        "Go Live": "#85E8B3",
        "UNKNOWN":"#FF0000",
        "New": "#FFE168",
        "In Progress": "#FDBE4F",
        "Need More Information": "#89DBE9",
        "Pending Customer Action":"#C3BDFE",
        "Completed": "#85E8B3",
        "Closed": "#B2B2B2",
        "Cancelled": "#FFB2B2",
        "Customer Feedback Awaited": "#C3BDFE",
        "Received":"#FFE168",
        "On Hold":"#CDCDCD",
        "Active Users":"#85E8B3",
        "Inactive Users":"#B2B2B2",
        "Deleted Users":"#FFB2B2",
        "Pending":"#FDBE4F",
        "Approved":"#85E8B3",
        "Rejected":"#FFB2B2",
    };

    const visibleData = statusData?.filter(item => !hiddenItems?.includes(item?.name));
    const shouldShowRetry = (
        (action === WIDGET_NAME.INCIDENT_MANAGEMENT_STATUS_COUNT_WIDGET && !props?.incidentGraphData?.statusCount) ||
        (action === WIDGET_NAME.DEMANDS_STATUS_COUNT_WIDGET && !props?.demandGraphData?.statusCount)
      );
      
    const handleRetry = (type,selectedDates) => {
        const startDate = selectedDates[0]
        const endDate = selectedDates[selectedDates?.length-1]
        const retryActions = {
        [WIDGET_NAME.INCIDENT_MANAGEMENT_STATUS_COUNT_WIDGET]: props.getIncidentGraph,
        [WIDGET_NAME.DEMANDS_STATUS_COUNT_WIDGET]: props.getDemandGraph,
        [WIDGET_NAME.CUSTOMER_ONBOARDING_REQUESTS_WIDGET]: props.getOnboardingData,
        [WIDGET_NAME.STATUS_WISE_CUSTOMER_USERS_COUNT_WIDGET]: props.getCustomerUserCount,
        };
    
        const retryFn = retryActions[type];
        if (retryFn) {
        retryFn(type, selectedOption?.value,selectedCustomerId,startDate,endDate);
        }
    };
    const calendarActionHandler = {
        onApply: (selectedDates, customLabel, type) => {
          setSelectValue({ label: customLabel, value: selectedDates });
          handleRetry(type,selectedDates);
          setIsCustom(false);
        },
        setSelectValue: setSelectValue,
        setIsCustom: setIsCustom,
      };
    return (
        <div className={styles.graphwidget}>
            <div className={styles.graphheaderwrapper}>
            {action===WIDGET_NAME.STATUS_WISE_CUSTOMER_USERS_COUNT_WIDGET? <div className={styles.graphheader}>User Management</div>:
            action===WIDGET_NAME.CUSTOMER_ONBOARDING_REQUESTS_WIDGET? <div className={styles.graphheader}>Customer Onboarding Requests</div>:
            <div className={styles.graphheader}>
                {`${dropdownHeader} - ${selectedOption?.value? selectedOption?.label : ""}`}{" "}
                <CustomDropdownMenu
                header={dropdownHeader}
                options={dropdownOptions}
                selectedValue={selectedOption}
                onSelect={(option) => setSelectedOption(option)}
                renderTrigger={(isOpen) => (
                selectedOption?.value?<img className={`${styles.arrows} ${isOpen ? styles.rotateArrow : ""}`} src={IMAGES.arrows} alt="dropdown arrow"/>:<div className={styles.shimmerlabel}><Shimmer/></div>
            )}
                />
            </div>}
                <div className={styles.wrapparent}>
                    <div className={styles.retryparent} onClick={()=>handleRetry(action,selectValue?.value)}> <div className={styles.retryicon}></div><div className={styles.refresh}>Refresh</div></div>
                    <div className={styles.seprator}></div>
                    <Link to={gotoDetail(action)} target="_blank" rel="noopener noreferrer" className={styles.viewdetailsparent}> 
                        <div className={styles.viewdetailicon}></div><div className={styles.detailtext}>View Details</div>
                    </Link>
                </div>
            </div>
            <div className={styles.graphsubheader}>
                {action===WIDGET_NAME.STATUS_WISE_CUSTOMER_USERS_COUNT_WIDGET?<div className={styles.subheader}>{`Last Updated On: ${dashboardTime(getUTCTimestamp())}`} <SecondaryTooltip text={"The graph below presents data of customer's users."} positions={['bottom', 'right']}><img className={styles.circleinfo} src={IMAGES.infoCircle}/></SecondaryTooltip></div>:<>
                <div className={styles.subheader}>{`${selectValue?.label}`}</div>
                <div className={styles.seprator}></div>
                <div className={styles.customWrapper}><div className={styles.customDate} onClick={()=>setIsCustom((prev)=>!prev)}>Custom</div>
                {isCustom && (
                    <Calendar 
                    actions={calendarActionHandler}
                    initialValues={{
                        selectedYear: extractYearFromValue(selectValue.value),
                        selectedMonths: selectValue.value,
                        selectionType: determineSelectionType(selectValue.value),
                        multiSelect:true}}
                    isCustom={isCustom}
                    type={action}/>)}
                </div>
                </>}
            </div>
            {action===WIDGET_NAME.INCIDENT_MANAGEMENT_STATUS_COUNT_WIDGET&&props?.isLoading?<div className={styles.shimmerbody}><Shimmer/></div>:
            (action===WIDGET_NAME.DEMANDS_STATUS_COUNT_WIDGET&&props?.isDemandLoading||props?.demandOptionLoading)?<div className={styles.shimmerbody}><Shimmer/></div>:
            (action===WIDGET_NAME.CUSTOMER_ONBOARDING_REQUESTS_WIDGET&&props?.onBoardingRequestLoading)?<div className={styles.shimmerbody}><Shimmer/></div>:
            (action===WIDGET_NAME.STATUS_WISE_CUSTOMER_USERS_COUNT_WIDGET&&props?.custUserCountLoading)?<div className={styles.shimmerbody}><Shimmer/></div>:
            <div className={styles.graphbody}>
                {data?.length>0&& data?
                <>
                <div className={styles.graphbodywrapper}>
                    <div className={styles.leftpart}>
                        <DashboardPieChart ref={chartRef} data={visibleData} colorMap={colorMap} />
                        <div className={styles.totalcount}>Total: {total} {`${GraphLabel[action]??"Requests"}`}</div>
                       {selectedOption?.value == "OTHERS" &&<div className={styles.servicetypes}>Transport | Sigtran | Diameter | DNS | HTTP2</div>}
                    </div>
                    <div className={styles.rightpart}>
                    <div className={styles.legends}>
                    {data?.map((item,index)=>(
                        item?.value===0?
                        <div 
                          key={index}
                          className={`${styles.parent} ${styles.disablelegends}`}
                        >
                        <div className={styles.disablelegendeitem}>
                            <div className={styles.ball} 
                        style={{backgroundColor:colorMap[item.name],
                            border: hiddenItems.includes(item.name) ? '1px solid #999' : 'none'}}></div><span className={styles.itemname}>{item.name}</span></div>
                        <div className={styles.itemcount}>{item.value}</div>
                        </div>:
                        <div 
                          key={item.name}
                          className={`${styles.parent} ${hiddenItems.includes(item?.name)&&styles.disablelegends}`}
                        >
                        <div className={styles.legendeitem}
                        onMouseEnter={() => chartRef.current?.highlightSlice(item.name)}
                        onMouseLeave={() => chartRef.current?.downplaySlice(item.name)}
                        onClick={() => {
                          setHiddenItems(prev =>
                              prev.includes(item?.name)
                              ? prev.filter(name => name !== item?.name): [...prev, item.name]);}}><div className={styles.ball} 
                        style={{backgroundColor:colorMap[item?.name],
                            border: hiddenItems?.includes(item?.name) ? '1px solid #999' : 'none'}}></div><span className={styles.itemname}>{item.name}</span></div>
                        <div className={styles.itemcount}>{item.value}</div>
                        </div>
                    ))}
                </div> 
                    </div>
                </div>
                </>
                :<EmptyDataView/>}
            </div>}
        </div>
    )
}
const mapStateToProps = (state) => {
    return {
        services:state.newService.services.services.services,
        incidentGraphData:state?.dashBoardCounts?.incidentGraphData?.data,
        isLoading:state?.dashBoardCounts?.incidentGraphData?.isLoading,
        demandGraphData:state?.dashBoardCounts?.demandGraphData?.data,
        isDemandLoading:state?.dashBoardCounts?.demandGraphData?.isLoading,
        myRights : state.myRights.myRights,
        demandOptionLoading:state.newService.services?.loading,
        onBoardingRequestData:state?.dashBoardCounts?.onBoardingRequestData?.data,
        onBoardingRequestLoading:state?.dashBoardCounts?.onBoardingRequestData?.isLoading,
        statusWiseCustomerUserCount:state?.dashBoardCounts?.statusWiseCustomerUserCount?.data,
        custUserCountLoading:state?.dashBoardCounts?.statusWiseCustomerUserCount?.isLoading,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setIncidentActiveTab: (tab) => {
            return dispatch(setIncidentActiveTab(tab))
        },
        setServiceActiveTab: (tab) => {
            return dispatch(setServiceActiveTab(tab))
        },
        getIncidentGraph: (action,filterOptions="",uniqueCustomerRefId="",startDate="",endDate="") => {
            return dispatch(getIncidentGraph(action,filterOptions,uniqueCustomerRefId,startDate,endDate))
        },
        getDemandGraph: (action,filterOptions="",uniqueCustomerRefId="",startDate="",endDate="") => {
            return dispatch(getDemandGraph(action,filterOptions,uniqueCustomerRefId,startDate,endDate))
        },
        redirectDemandFilter: (Filter) => {
            return dispatch(redirectDemandFilter(Filter))
        },
        getOnboardingData: (action,filterOptions="",uniqueCustomerRefId="",startDate="",endDate="") => {
            return dispatch(getOnboardingData(action,filterOptions,uniqueCustomerRefId,startDate,endDate))
        },
        setActivePrimaryTab: (tab) => {
            return dispatch(setActivePrimaryTab(tab))
        },
        getCustomerUserCount: (action,filterOptions="",uniqueCustomerRefId="") => {
            return dispatch(getCustomerUserCount(action,filterOptions,uniqueCustomerRefId))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(GraphWidget);